import { jsx as C } from "react/jsx-runtime";
function t(L) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "24",
      height: "23",
      viewBox: "0 0 24 23",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--brand-primary))",
      ...L,
      children: /* @__PURE__ */ C("path", { d: "M23.375 8.56255C23.375 8.4382 23.3464 8.31551 23.2914 8.20394C23.2365 8.09238 23.1567 7.99491 23.0581 7.91905L13.4861 0.556178C13.06 0.228463 12.5375 0.0507812 12 0.0507812C11.4625 0.0507812 10.94 0.228463 10.5139 0.556178L0.941875 7.91905C0.843334 7.99491 0.76352 8.09238 0.708582 8.20394C0.653645 8.31551 0.62505 8.4382 0.625 8.56255V19.9376C0.630307 20.5824 0.888819 21.1993 1.34479 21.6553C1.80077 22.1112 2.41768 22.3697 3.0625 22.3751H20.9375C21.5363 22.3798 22.1144 22.1564 22.5544 21.7502L22.5625 21.7405L22.5747 21.7316C22.5796 21.7267 22.5804 21.721 22.5853 21.7161C22.8334 21.4909 23.0318 21.2164 23.1678 20.9102C23.3038 20.6039 23.3743 20.2726 23.375 19.9376V8.56255ZM21.75 19.9091L15.4458 15.0626L21.75 10.2127V19.9091ZM12.4948 1.84318L21.23 8.56255L14.1125 14.0372L13.4861 13.5562C13.06 13.2285 12.5375 13.0508 12 13.0508C11.4625 13.0508 10.94 13.2285 10.5139 13.5562L9.8875 14.0372L2.77 8.56255L11.5044 1.84318C11.6464 1.73401 11.8205 1.67482 11.9996 1.67482C12.1787 1.67482 12.3528 1.73401 12.4948 1.84318ZM8.55419 15.0626L2.25 19.9091V10.2127L8.55419 15.0626ZM3.82219 20.7501L11.5044 14.8432C11.6464 14.734 11.8205 14.6748 11.9996 14.6748C12.1787 14.6748 12.3528 14.734 12.4948 14.8432L20.1778 20.7501H3.82219Z" })
    }
  );
}
export {
  t as OpenedLetterIcon
};
